import { render, staticRenderFns } from "./UserResetPwd.vue?vue&type=template&id=81c387be"
import script from "./UserResetPwd.vue?vue&type=script&lang=js"
export * from "./UserResetPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports